import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import {
  DateRange,
  DEFAULT_DATE_RANGE,
  DEFAULT_REPORT_EXPENSES_SPEND_TABLE_COLUMNS,
  ReportExpensesSpendTableColumnKeys,
} from "../components";
import {
  ExpenseReportAnalyticGroup,
  FilterCategoryEnum,
  FilterOption,
} from "@common/utils/graphql";
import { storageWithDateRange } from "../utils";

type Inputs = {
  dateRange: DateRange;
  groupedBy: ExpenseReportAnalyticGroup;
  groupByCustomFieldEntityId: number | null;
  filterOptions: FilterOption[];
  spendTableColumns: ReportExpensesSpendTableColumnKeys[];
};

const DEFAULT_INPUTS: Inputs = {
  dateRange: DEFAULT_DATE_RANGE,
  groupedBy: ExpenseReportAnalyticGroup.PaymentMethod,
  groupByCustomFieldEntityId: null,
  filterOptions: [
    // TODO: Update this to match BE
    {
      category: FilterCategoryEnum.ExpenseStatus,
      displaySubtitle: "Expense Status",
      displayTitle: "Approved",
      id: "approved",
    },
  ],
  spendTableColumns: DEFAULT_REPORT_EXPENSES_SPEND_TABLE_COLUMNS,
};

type ReportsTabInputsState = Inputs & {
  upsert: (inputs: Partial<Inputs>) => void;
  reset: () => void;
};

export const useReportsTabInputs = create<ReportsTabInputsState>()(
  devtools(
    persist(
      (set) => ({
        ...DEFAULT_INPUTS,
        upsert: (inputs) => set((state) => ({ ...state, ...inputs })),
        reset: () => set(DEFAULT_INPUTS),
      }),
      {
        name: "reports-tab-inputs",
        storage: storageWithDateRange,
      },
    ),
  ),
);
